import Scene from "../../../../src/controls/scene-control";
import Chapter from "../../../../src/controls/chapter-control";
import YouTube from "../../../../src/controls/youtube-control";
import Legend from "../../../../src/controls/legend-control";
import Expando from "../../../../src/controls/expando-control";
import LinkToScene from "../../../../src/controls/link-to-scene-control";
import Carousel from "../../../../src/controls/carousel-control";
import ExternalLink from "../../../../src/controls/external-link-control";
import Image from "../../../../src/controls/image-control";
import Icon from "../../../../src/controls/icon-control";
import * as React from 'react';
export default {
  Scene,
  Chapter,
  YouTube,
  Legend,
  Expando,
  LinkToScene,
  Carousel,
  ExternalLink,
  Image,
  Icon,
  React
};